import { useApiQuery } from "../api/hooks";
import { ShapeDrawing } from "./ShapeDrawing";

interface ShapeByCodeProps {
  code: string;
  kind: "symbol" | "line_style";
  label: string;
  size?: number;
  className?: string;
}

/** The drawing of a symbol or line style named by its code, read from the symbol set (once, then shared). Nothing is
 * shown for a code that is in neither the library nor this discipline. */
export function ShapeByCode({ code, kind, label, size = 40, className }: ShapeByCodeProps) {
  const set = useApiQuery("symbol_set", {}, { staleTime: 60_000 });
  const item = set.data?.items.find((entry) => entry.code === code && entry.kind === kind);
  if (!item) return null;
  return <ShapeDrawing shape={item.shape} kind={kind} label={label} size={size} className={className} />;
}
